import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";

function Workflowprocess() {
  return (
    <section
      className="workflow_process p-100"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Our Full-fledged <span>Android App</span> Development Process
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              The process we follow in Android app development is a
              well-structured journey that begins with a thorough project scope
              determination early in the project life cycle. We then venture
              into a series of iterative cycles, leveraging Agile methodologies
              and sprints, to bring your product to life.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="my-auto">
            <div className="workflow_main">
              <div className="workflow_process_item">
                <div className="workflow_process_img">{PlaneIcon}</div>
                <div className="workflow_process_content">
                  <h5>Project Plan</h5>
                  <p>
                    We use scrum methodologies to construct a path for
                    development prioritizing items from the backlog.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{DesignIcon}</div>
                <div className="workflow_process_content">
                  <h5>UI/UX Design</h5>
                  <p>
                    Our Android app designers craft a user-friendly and visually
                    appealing user interface with a seamless experience in this
                    phase.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{BuildIcon}</div>
                <div className="workflow_process_content">
                  <h5>Core Development</h5>
                  <p>
                    Our Android app developers transform the design into a
                    functional Android app using a recent tech stack.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{TestIcon}</div>
                <div className="workflow_process_content">
                  <h5>Quality Assurance</h5>
                  <p>
                    To ensure your app works properly, rigorous testing is
                    conducted to identify and rectify any bugs.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{LaunchIcon}</div>
                <div className="workflow_process_content">
                  <h5>App Launch</h5>
                  <p>
                    Your Android app is ready to make its debut on the Google
                    Play Store, reaching its intended audience.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{MaintenanceIcon}</div>
                <div className="workflow_process_content">
                  <h5>App Maintenance</h5>
                  <p>
                    We provide ongoing support and updates to keep your app
                    up-to-date and responsive to your needs.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Workflowprocess;
